'use es6';

import PropTypes from 'prop-types';
import { usePrefetchAccessLevels } from 'customer-data-properties/accessLevel/AccessLevelContext';
import { jsx as _jsx } from "react/jsx-runtime";
const withAccessLevelPrefetch = WrappedComponent => {
  const AccessLevelWrapper = props => {
    usePrefetchAccessLevels({
      objectTypes: [props.objectTypeId]
    });
    return /*#__PURE__*/_jsx(WrappedComponent, Object.assign({}, props));
  };
  AccessLevelWrapper.propTypes = {
    objectTypeId: PropTypes.string.isRequired
  };
  AccessLevelWrapper.displayName = 'WithAccessLevelPrefetch';
  return AccessLevelWrapper;
};
export default withAccessLevelPrefetch;